import { Controller } from "@hotwired/stimulus"

// row 전체를 클릭 가능 영역으로 — turbo_frame 갱신 + 시각 선택 표시 (row-selected class).
// row-select controller 의 sessionStorage/back navigation 패턴과 별개로,
// master-detail 화면에서 turbo_frame 만 갱신할 때 사용.
//
// 사용법:
//   <tr data-controller="row-clickable"
//       data-row-clickable-url-value="/path/to/detail"
//       data-row-clickable-frame-value="turbo_frame_id"   (옵션 — 없으면 Turbo.visit)
//       data-action="click->row-clickable#navigate">
//
// row 안의 <a>/<button>/<input>/<select>/<form> 등 자체 인터랙티브 요소는 우선 처리 (가로채지 않음).
// 클릭 시 같은 <tbody> 내 다른 row 의 row-selected 를 모두 제거하고 본 row 에만 부여.
export default class extends Controller {
  static values = {
    url: String,
    frame: String,
  }

  navigate(event) {
    // 안의 인터랙티브 요소 자체 클릭은 row 클릭으로 가로채지 않음
    if (event.target.closest("a, button, input, select, textarea, label, form")) return

    // 같은 tbody 내 다른 row 의 row-selected 제거 후 본 row 에 부여
    const tbody = this.element.closest("tbody")
    if (tbody) {
      tbody.querySelectorAll("tr.row-selected").forEach((r) => r.classList.remove("row-selected"))
    }
    this.element.classList.add("row-selected")

    // Turbo Frame 갱신 우선, 없으면 Turbo.visit
    if (this.frameValue) {
      const frame = document.getElementById(this.frameValue)
      if (frame && frame.tagName === "TURBO-FRAME") {
        frame.src = this.urlValue
        return
      }
    }
    if (window.Turbo) {
      window.Turbo.visit(this.urlValue)
    } else {
      window.location.href = this.urlValue
    }
  }
}
